import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Navbar from "../core/Navbar";
import Footer from "../core/Footer";

const TandCPage = () => {
  const verbatimText = `Terms to stay informed of updates.
The use of this website or availing of our Services is subject to the following terms of use:
-To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account.
-Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials offered on this website or through the Services, for any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
-Your use of our Services and the website is solely at your own risk and discretion.. You are
required to independently assess and ensure that the Services meet your requirements.
The contents of the Website and the Services are proprietary to Us and you will not have any
authority to claim any intellectual property rights, title, or interest in its contents.
-You acknowledge that unauthorized use of the Website or the Services may lead to action against you as per these Terms or applicable laws.
-You agree to pay us the charges associated with availing the Services.
-You agree not to use the website and/ or Services for any purpose that is unlawful, illegal or
forbidden by these Terms, or Indian or local laws that might apply to you.
-You agree and acknowledge that website and the Services may contain links to other third party websites. On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third party websites.
-You understand that upon initiating a transaction for availing the Services you are entering into a legally binding and enforceable contract with the us for the Services.
- You shall be entitled to claim a refund of the payment made by you in case we are not able to provide the Service. The timelines for such return and refund will be according to the specific Service you have availed or within the time period provided in our policies (as applicable). In case you do not raise a refund claim within the stipulated time, than this would make you ineligible for a refund.
-Notwithstanding anything contained in these Terms, the parties shall not be liable for any failure to perform an obligation under these Terms if performance is prevented or delayed by a force majeure event.
-These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of India.
-All disputes arising out of or in connection with these Terms shall be subject to the exclusive
jurisdiction of the courts in Bathinda, Punjab 
-All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website.`;

  return (
    <>
      <Navbar />

      <main>
        {/* Hero / Title Section */}
        <header className="bg-light py-5">
          <Container>
            <Row className="justify-content-center text-center">
              <Col
                xs={12}
                md={10}
                lg={8}
              >
                <h1 className="display-6 fw-bold">Terms & Conditions</h1>
                <p className="text-muted mt-2">
                  Please read these terms carefully before using our website or
                  services.
                </p>
              </Col>
            </Row>
          </Container>
        </header>

        {/* Content Section */}
        <section className="py-5">
          <Container>
            <Row className="justify-content-center">
              <Col
                xs={12}
                md={10}
                lg={8}
              >
                <Card className="shadow-sm mb-4">
                  <Card.Body>
                    <Card.Text
                      as="div"
                      style={{ lineHeight: 1.8 }}
                    >
                      <p>
                        These Terms and Conditions, along with privacy policy or
                        other terms (“Terms”) constitute a binding agreement by
                        and between{" "}
                        <strong>
                          HIGH1 DIGITAL CONSULTING PRIVATE LIMITED
                        </strong>
                        , (“Website Owner” or “we” or “us” or “our”) and you
                        (“you” or “your”) and relate to your use of our website,
                        goods (as applicable) or services (as applicable)
                        (collectively, “Services”).
                      </p>

                      <p>
                        By using our website and availing the Services, you
                        agree that you have read and accepted these Terms
                        (including the Privacy Policy). We reserve the right to
                        modify these Terms at any time and without assigning any
                        reason. It is your responsibility to periodically review
                        these Terms to stay informed of updates.
                      </p>

                      <p>
                        The use of this website or availing of our Services is
                        subject to the following terms of use:
                      </p>

                      <ul>
                        <li>
                          To access and use the Services, you agree to provide
                          true, accurate and complete information to us during
                          and after registration, and you shall be responsible
                          for all acts done through the use of your registered
                          account.
                        </li>
                        <li>
                          Neither we nor any third parties provide any warranty
                          or guarantee as to the accuracy, timeliness,
                          performance, completeness or suitability of the
                          information and materials offered on this website or
                          through the Services, for any specific purpose. You
                          acknowledge that such information and materials may
                          contain inaccuracies or errors and we expressly
                          exclude liability for any such inaccuracies or errors
                          to the fullest extent permitted by law.
                        </li>
                      </ul>
                    </Card.Text>
                  </Card.Body>
                </Card>

                {/* Inserted verbatim block exactly as provided */}
                <Card className="shadow-sm mb-4">
                  <Card.Body>
                    <pre
                      style={{
                        whiteSpace: "pre-line",
                        fontFamily: "inherit",
                        border: "none",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      {verbatimText}
                    </pre>
                  </Card.Body>
                </Card>

                <Card className="shadow-sm">
                  <Card.Body>
                    <h5>Updates to Terms</h5>
                    <p className="mb-0">
                      We reserve the right to update or revise these Terms at
                      any time without prior notice. Continued use of our
                      website or services after such updates constitutes your
                      acceptance of the revised Terms.
                    </p>
                  </Card.Body>
                </Card>

                <p className="text-muted small mt-4">
                  For questions regarding these Terms, please contact us at{" "}
                  <a
                    href="mailto:sales@high1digital.com"
                    className="text-decoration-none"
                  >
                    sales@high1digital.com
                  </a>
                  .
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default TandCPage;
